import { Link } from 'gatsby';
import classNames from 'classnames';
import React, { useState, createRef } from 'react';

import ExamLinks from '@components/libraryV2/ExamLinks';
import OutsideAlerter from '@components/libraryV2/OutsideAlerter';
import LinkButton from '@components/libraryV2/LinkButton';
import LogoLink from '@components/libraryV2/LogoLink';

import * as styles from './styles.module.scss';

const NavLink = (props) => {
  const { children, to } = props;

  return (
    <Link className={styles.navLink} to={to}>
      {children}
    </Link>
  );
};

const CoursesButton = ({ examsOpen, toggleExams }) => (
  <div className={styles.navLink} onClick={toggleExams}>
    Courses{' '}
    <i
      className={classNames(
        examsOpen ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down',
        styles.caret
      )}
    />
  </div>
);

const SignInButton = () => (
  <LinkButton className={styles.signIn} href="https://app.achievable.me/auth/sign-in/">
    Sign in
  </LinkButton>
);

const NavBars = ({ navOpen, toggleNav }) => {
  const iconClass = navOpen ? 'fa-solid fa-times' : 'fa-solid fa-bars';
  return (
    <div
      className={styles.navBars}
      aria-label="Toggle navigation menu"
      onClick={toggleNav}
      role="button"
      tabIndex="0"
    >
      <i id="navToggle" className={iconClass} />
    </div>
  );
};

const DesktopNavigation = ({ examsOpen, toggleExams }) => (
  <div className={styles.navigationDesktop}>
    <NavLink to="/about/">About</NavLink>
    <NavLink to="/enterprise/">Enterprise</NavLink>
    <NavLink to="/reviews/">Reviews</NavLink>
    <NavLink to="/scholarship/">Scholarship</NavLink>
    <NavLink to="/tutors/">Tutors</NavLink>
    <CoursesButton examsOpen={examsOpen} toggleExams={toggleExams} />
    <SignInButton />
  </div>
);

const MobileNavigation = ({ closeNav, examsOpen, toggleExams }) => {
  const wrapperRef = createRef();

  return (
    <>
      <div className={styles.background} />
      <div className={styles.navigationMobile}>
        <div className={styles.mobileLinks} ref={wrapperRef}>
          <OutsideAlerter wrapperRef={wrapperRef} onClick={closeNav}>
            {examsOpen ? (
              <>
                <CoursesButton examsOpen={examsOpen} toggleExams={toggleExams} />
                <div className={styles.examsMobile}>
                  <ExamLinks className={styles.examMobile} withCard />
                </div>
                <SignInButton />
              </>
            ) : (
              <>
                <NavLink to="/about/">About</NavLink>
                <NavLink to="/enterprise/">Enterprise</NavLink>
                <NavLink to="/reviews/">Reviews</NavLink>
                <NavLink to="/tutors/">Tutors</NavLink>
                <NavLink to="/scholarship/">Scholarship</NavLink>
                <CoursesButton examsOpen={examsOpen} toggleExams={toggleExams} />
                <SignInButton />
              </>
            )}
          </OutsideAlerter>
        </div>
      </div>
    </>
  );
};

const Header = () => {
  const [examsOpen, setExamsOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const wrapperRef = createRef();

  const closeExams = () => {
    setExamsOpen(false);
  };

  const toggleExams = () => {
    setExamsOpen((prev) => !prev);
  };

  const closeNav = (event) => {
    if (event.target.id !== 'navToggle') {
      setExamsOpen(false);
      setNavOpen(false);
    }
  };

  const toggleNav = () => {
    setNavOpen((prev) => !prev);
  };

  return (
    <div className={styles.layout} ref={wrapperRef}>
      <div className={styles.navigation}>
        <LogoLink />
        <NavBars navOpen={navOpen} toggleNav={toggleNav} />
        <DesktopNavigation examsOpen={examsOpen} toggleExams={toggleExams} />
      </div>
      {navOpen && (
        <MobileNavigation
          closeNav={closeNav}
          examsOpen={examsOpen}
          toggleExams={toggleExams}
        />
      )}
      {examsOpen && (
        <OutsideAlerter wrapperRef={wrapperRef} onClick={closeExams}>
          <div className={styles.examsDesktop}>
            <div className={styles.examLinks}>
              <ExamLinks />
            </div>
          </div>
        </OutsideAlerter>
      )}
    </div>
  );
};

export default Header;
